import type { BadgeProps } from '@wartek-id/badge'
import { Badge } from '@wartek-id/badge'

import type { PengawasSchool } from 'types/kinerja-ks-pelaksanaan'
import type { FC } from 'react'

interface BadgePerilakuKerjaProps {
  status: PengawasSchool['perilakuKerjaStatus']
  colorFinished?: BadgeProps['variant']
  colorNotFinished?: BadgeProps['variant']

  useNewMapping?: boolean
}

const NEW_MAPPING_STATUS: Record<string, string> = {
  'sudah dinilai': 'Sudah Selesai',
  'belum dinilai': 'Belum Selesai',
}

const BadgePerilakuKerja: FC<BadgePerilakuKerjaProps> = ({
  status = null,
  colorFinished = 'success', // default color for finished status
  colorNotFinished = 'critical', // default color for not finished status

  useNewMapping = false,
}) => {
  if (!status) return <>-</>

  return (
    <Badge
      variant={
        status?.toLowerCase() == 'sudah dinilai'
          ? colorFinished
          : colorNotFinished
      }
    >
      {useNewMapping
        ? NEW_MAPPING_STATUS[status.toLowerCase()] || status
        : status}
    </Badge>
  )
}
export default BadgePerilakuKerja
